import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { isEllipsisActive } from '../../utils/helpers'
import Tooltip from '../atoms/Tooltip'

export const TruncatedTextWithTooltip = ({ text, children, clampedRows = 3 }) => {
  const [showToolTip, setShowToolTip] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (isEllipsisActive(ref.current)) {
      setShowToolTip(true)
    }
  }, [])

  return (
    <Tooltip
      title={text}
      placement="bottom-start"
      classes={{ popper: 'tooltip-offset-top' }}
      disableHoverListener={!showToolTip}
    >
      {children ? (
        children({ ref, className: 'truncate-text-x-rows', style: { WebkitLineClamp: clampedRows } })
      ) : (
        <span ref={ref} className="truncate-text-x-rows" style={{ WebkitLineClamp: clampedRows }}>
          {text}
        </span>
      )}
    </Tooltip>
  )
}

TruncatedTextWithTooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  clampedRows: PropTypes.number,
  text: PropTypes.string
}
